(ns common.schema.registry
  (:require
   [clojure.set :as set]
   [common.currencies :as currencies]
   [common.schema.assets :as assets]
   [common.schema.data-types :as data-types]
   [common.schema.entities.activity :as activity]
   [common.schema.entities.common :as common]
   [common.schema.entities.custom-field :as custom-field]
   [common.schema.entity-types :as entity-types]
   [common.util :as cu]
   [potpuri.core :as potpuri :refer [fn->]]))

(def company-fields-order-old
  {:company/marketing-plan                                      127
   :company/cur-revenue-le-for-current-year                     50
   :company/product-service                                     149
   :company/cur-short-term-advances                             73
   :company/tag-head-count                                      213
   :company/industry-category                                   125
   :company/cur-necessary-investments-this-year                 75
   :company/news                                                144
   :company/tag-ownership                                       214
   :company/ipr                                                 170
   :company/proposed-use-of-proceeds                            161
   :company/cur-revenue-ltm                                     57
   :company/cur-tesi-net-working-capital                        74
   :company/cur-proposed-pre-money-valuation                    182
   :company/cur-ebitda-last-known                               91
   :company/tag-type                                            215
   :company/market-opportunities                                106
   :company/cur-tesi-ebitda-2019                                47
   :company/number-of-customers                                 185
   :company/parent-company                                      136
   :company/cur-proposed-funding-from-us                        82
   :company/tag-maturity                                        216
   :company/company-due-diligence                               129
   :company/last-known-24m-growth-rate                          100
   :company/architecture                                        109
   :company/crunchbase                                          139
   :company/possible-attack-vectors                             114
   :company/cur-revenue-last-calendar-year                      38
   :company/market-growth                                       163
   :company/revenue-le-for-current-year-comment                 51
   :company/cur-clv                                             63
   :company/tesi-identified-corona-mitigation-without-funding   68
   :company/cur-cash-balance-last-month                         101
   :company/token-intrinsic-value                               121
   :company/linkedin                                            138
   :company/cluster                                             20
   :company/market-challenges                                   107
   :company/strengths                                           123
   :common/attachments                                          198
   :company/cur-tesi-revenue-2019                               43
   :company/cur-proposed-equity-round-size                      181
   :company/irl                                                 174
   :company/TOL-A                                               31
   :company/main-actors                                         110
   :company/ebitda-last-calendar-year-comment                   49
   :company/cur-accounts-payable                                86
   :company/indication                                          172
   :company/one-line-description                                199
   :company/current-owners                                      66
   :company/background                                          148
   :company/tag-business-unit-function                          217
   :company/phone                                               8
   :company/impact-of-costs-cuts                                64
   :company/customer-identification-number                      12
   :company/earnings-logic                                      164
   :company/company-business-type                               135
   :company/tag-stage                                           218
   :company/cur-previous-round-valuation                        180
   :company/tesi-ebitda-percentage                              211
   :company/questions                                           122
   :company/cur-tesi-revenue-2020                               44
   :company/opportunities                                       162
   :company/youtube                                             146
   :company/revenue-last-calendar-year-comment                  39
   :company/applications                                        115
   :company/tag-credit-rating                                   220
   :company/cur-tesi-net-debt-per-ebitda                        208
   :company/tag-potential-buyers                                221
   :company/cur-tesi-ebitda-2020                                48
   :company/cur-balance-sheet-size                              84
   :company/financials                                          35
   :company/global-acceleration-academy                         27
   :company/number-of-employees                                 183
   :company/current-owner                                       186
   :company/hkstp-office-location                               23
   :company/preferred-funding-structure                         25
   :company/cur-capital-raised                                  179
   :company/description-of-ongoing-investor-talks               165
   :company/tag-product-category                                200
   :company/tesi-net-working-capital-percentage                 210
   :company/received-grants                                     194
   :company/sales-pipeline                                      126
   :company/last-known-12m-growth-rate                          99
   :company/cur-burn-rate                                       87
   :company/lead-investors                                      188
   :company/hkai-lab                                            26
   :company/risks                                               124
   :company/subsidiaries                                        190
   :company/facebook                                            140
   :company/scalable-business                                   202
   :company/sector-broad                                        21
   :asset/city                                                  5
   :company/tag-potential-acquisition-targets                   222
   :company/cur-proposed-funding-from-non-govt-sources          83
   :company/cur-previous-funding-round                          93
   :company/revenue-range-ltm                                   37
   :company/sector                                              19
   :company/cur-tesi-bang-for-buck                              206
   :company/partners                                            119
   :company/eis-due-diligence                                   130
   :company/weaknesses                                          153
   :asset/state                                                 6
   :asset/name                                                  0
   :company/date-of-previous-funding-round                      94
   :company/cur-gross-profit-last-known                         89
   :company/cur-total-available-market                          176
   :company/tag-fit                                             223
   :company/tag-sub-sector                                      224
   :company/product-development-status                          33
   :company/cur-mrr                                             61
   :company/other-locations                                     9
   :company/need                                                108
   :company/verdict-sections                                    116
   :company/customer-segments                                   150
   :company/short-description-of-progress-during-last-12-months 158
   :company/tracxn                                              145
   :company/tag-industry-type                                   225
   :company/twitter                                             142
   :company/tesi-revenue-details                                155
   :company/tag-sector                                          227
   :company/why-part-of-maria-01                                189
   :company/tag-business-model                                  228
   :company/known-investors                                     173
   :company/sustainable-development-goals                       175
   :company/tag-category                                        229
   :company/cur-tesi-ebitda-2018                                46
   :company/tag-sales-model                                     230
   :company/cur-gross-profits-le-for-current-year               53
   :company/tag-industry                                        231
   :company/tag-risks                                           232
   :company/past-accelerators                                   192
   :asset/country                                               7
   :company/cur-current-assets                                  81
   :company/tag-size-category                                   233
   :company/technical-due-diligence                             128
   :company/customer-problem-solutions                          17
   :company/link-to-company-presentation                        197
   :company/tag-business-vertical-segment                       234
   :company/cur-current-cash-position-inc-bank-receivables      80
   :company/tokenomics                                          120
   :company/number-of-employees-in-Finland                      184
   :company/tesi-equity-ratio                                   207
   :company/tag-team-type                                       235
   :company/overview                                            14
   :company/lifecycle                                           30
   :company/last-known-6m-growth-rate                           98
   :company/cur-debt-balance-last-known                         102
   :company/tesi-runway                                         205
   :company/received-loans                                      195
   :company/TOL-B                                               32
   :company/tag-membership-category                             201
   :company/joint-ventures                                      137
   :company/financials-comment                                  132
   :company/cur-equity                                          79
   :company/duns-number                                         11
   :company/tesi-financials                                     36
   :company/cur-fixed-costs-current-last-month                  78
   :company/tesi-export-percentage-of-revenue                   95
   :company/current-financiers                                  166
   :company/outstanding-convertibles-options-and-warrants       187
   :company/cur-cash-and-bank-receivables-at-end-of-last-year   70
   :company/tesi-corona-percentage-impact-on-2020-ebitda        97
   :company/cur-ebitda-last-calendar-year                       40
   :company/cur-ebit-last-known                                 90
   :company/ebitda-ltm-comment                                  60
   :company/tag-strategy                                        236
   :company/customer-problems                                   16
   :company/next-development                                    118
   :company/past-incubators                                     191
   :company/proposed-round-participants                         24
   :company/problem-solution                                    18
   :company/established-in                                      13
   :company/cur-ebitda-ltm                                      59
   :company/cost-structure                                      167
   :company/tag-group                                           237
   :company/tag-value-chain                                     238
   :company/hometown                                            3
   :company/cur-costs-le-for-current-year                       52
   :company/cur-company-registered-capital                      134
   :company/cur-revenue-last-known                              88
   :company/tag-impact-metrics                                  226
   :company/tag-investor-type                                   239
   :company/angellist                                           141
   :company/cur-tesi-ebitda-2017                                45
   :company/tag-rating                                          240
   :company/cur-tesi-revenue-2018                               42
   :company/short-description-of-plans-for-next-12-months       159
   :company/cur-long-term-advances                              76
   :company/cur-interest-bearing-debt-at-end-of-last-year       71
   :company/cur-debt-balance-last-month                         103
   :company/technology                                          168
   :company/team                                                147
   :company/tesi-corona-percentage-impact-on-2020-revenue       96
   :company/tesi-corona-impact-on-business                      65
   :company/financials-model-analysis                           131
   :company/sector-sub                                          22
   :company/projected-ftes-moving-in                            204
   :company/cur-serviceable-available-market                    177
   :company/scaling-plans                                       169
   :company/business-id                                         10
   :company/short-description-of-key-stakeholders               160
   :company/cur-ebitda-le-for-current-year                      55
   :company/business-traction                                   34
   :company/cur-cash-balance-last-known                         92
   :company/competitive-advantages                              171
   :company/tag-strategic-fit                                   241
   :company/tag-m-n-a-potential                                 242
   :company/roadmap                                             117
   :company/ebitda-le-for-current-year-comment                  56
   :company/tag-target-markets                                  243
   :company/previous-rounds-description                         133
   :company/HQ-zip-code                                         4
   :company/cur-tesi-net-debt                                   67
   :company/cur-tesi-revenue-2017                               41
   :company/cur-cac                                             62
   :company/received-awards                                     193
   :company/tag-ipr                                             244
   :company/tesi-description-of-corona-mitigation               157
   :company/revenue-ltm-comment                                 58
   :asset/description                                           15
   :company/tag-technology                                      245
   :company/website                                             1
   :asset/street-address                                        2
   :company/cur-fixed-costs-last-year                           77
   :company/deterrents                                          112
   :company/cur-opex-le-for-current-year                        54
   :company/competition                                         152
   :company/cur-accounts-receivable                             85
   :company/cur-serviceable-obtainable-market                   178
   :company/category                                            28
   :company/product-development-stage                           29
   :company/target-market                                       104
   :company/business-model                                      105
   :company/cur-short-term-debt                                 72
   :company/cur-short-term-receivables                          69
   :company/concensus                                           113
   :company/datetime-preferred-starting-date                    203
   :company/tesi-main-expenses                                  156
   :company/incentives                                          111
   :company/quick-ratio                                         209
   :company/threats                                             154
   :company/tag-round                                           219
   :company/company-view-on-runway-in-months                    212
   :company/pitchbook                                           143})

(defn enrich-field-schema
  [base-index entity-type idx [field-key field-schema]]
  [field-key
   (merge {:field/default-ord      (or (get company-fields-order-old field-key)
                                       (+ base-index idx))
           :field/attribute        field-key
           :attribute              field-key
           :containing-entity-type entity-type}
          field-schema)])

(def common-ordered-schema
  (->> common/schema
       (map-indexed (partial enrich-field-schema 0 nil))
       (into {})))

(def common-field-count (count common-ordered-schema))

(def ordered-schemas
  (->> entity-types/entities
       (map (fn [[entity-type entity-info]]
              (let [schema (:entity/schema entity-info)]
                [entity-type
                 (->> schema
                      (map-indexed (partial enrich-field-schema 0 entity-type))
                      (into {})
                      (merge (->> common/schema
                                  (map-indexed (partial enrich-field-schema (count schema) nil))
                                  (into {}))))])))
       (into {})))

(def namespace-ordered-schemas
  (->> entity-types/entities
       (map (fn [[entity-type entity-info]]
              (let [schema (:entity/schema entity-info)]
                [entity-type
                 (->> schema
                      (map-indexed (partial enrich-field-schema common-field-count entity-type))
                      (into {}))])))
       (into {})))

(defn default-auth
  [fs et]
  (merge {:access/read  :role/user
          :access/write :role/user}
         (when (some #{:entity.type/named-value} (:field/entity-types fs))
           {:access/create :role/user})
         (cond
           (some #{et} [:entity.type/oppo])
           {:access/read  :role/guest-buy-side
            :access/write :role/guest-buy-side}
           (some #{et}
                 [:entity.type/company
                  :entity.type/real-estate
                  :entity.type/other-asset
                  :entity.type/fof-asset])
           {:access/read  :role/guest-sell-side
            :access/write :role/guest-sell-side})))

(defn default-visibility
  [data-type]
  (let [data-schema (get data-types/zapflow-data-types data-type)
        default-editor (:default-editor data-schema)
        default-filter (:default-filter data-schema)]
    {:editor           default-editor
     :grid             default-editor
     :filter           default-filter
     :field-visibility :in-use}))

(defn with-name-value-attribute
  [fs]
  (if (some #{:entity.type/named-value} (:field/entity-types fs))
    (assoc fs
      :named-value-attribute
      (:attribute fs))
    fs))

(defn add-data-specific-defaults
  [fs entity-schema]
  (case (:field/data-type fs)
    :data.type/currency-symbol
    (assoc fs
      :field/secondary-field? true
      :field/not-clearable? true
      :options currencies/options
      :value-type :keyword
      :field/related-fields (or (:field/related-fields fs)
                                (->> entity-schema
                                     (map second)
                                     (cu/filter-by :field/secondary-attribute (:field/attribute fs))
                                     (first)
                                     :field/attribute)))
    :data.type/ref-multi
    (-> fs
        (assoc :value-type :entity)
        (assoc :create-on-fly? true)
        (assoc :field/entity-types [:entity.type/named-value])
        (with-name-value-attribute))
    :data.type/ref-single
    (-> fs
        (assoc :value-type :entity)
        (assoc :field/entity-types [:entity.type/named-value])
        (assoc :create-on-fly? true)
        (with-name-value-attribute))
    fs))


(defn add-access-defaults
  [field-schema entity-type]
  (let [auth (default-auth field-schema
                           (or entity-type
                               (first (:field/for-entity-types
                                       field-schema))))]
    (assoc field-schema :field/default-authorization auth)))

(defn add-field-defaults
  [k field-schema entity-type entity-schema]
  (let []
    [k
     (-> (assoc field-schema
           :attribute k
           :field/translations {:en (:field/name field-schema)}
           :containing-entity-type entity-type
           :field/default-visibility (default-visibility (:field/data-type field-schema))
           :field/constraints [])
         (add-data-specific-defaults entity-schema)
         (add-access-defaults entity-type))]))

(defn custom-fields-for-entity-type
  [tenant-schema entity-type]
  (let [entity-fields (->> tenant-schema
                           (filter (fn [[_k m]]
                                     (let [for-types (:field/for-entity-types m)]
                                       (and (coll? for-types)
                                            (or (some #{entity-type} (:field/for-entity-types m))
                                                (and (some #{:entity.type/activity} (:field/for-entity-types m))
                                                     (some #{entity-type} activity/activity-entity-types))))))))]
    (->> entity-fields
         (map (fn [arg]
                (let [r (add-field-defaults (first arg) (second arg) entity-type entity-fields)]
                  r)))
         (into {}))))

(defn get-schema
  [tenant-schema entity-type]
  (let [static-entity-schema (get ordered-schemas entity-type)
        static-count (count static-entity-schema)
        custom-fields (custom-fields-for-entity-type tenant-schema entity-type)]
    (if (empty? custom-fields)
      static-entity-schema
      (merge static-entity-schema
             (->> custom-fields
                  (map-indexed (fn [idx [k m]]
                                 [k
                                  (merge m
                                         {:field/default-ord (+ static-count idx)})]))
                  (into {}))))))

(defn get-namespace-schema
  [tenant-schema entity-type]
  (let [namespace-schema (get namespace-ordered-schemas entity-type)
        custom-fields (custom-fields-for-entity-type tenant-schema entity-type)]
    (if (empty? custom-fields)
      namespace-schema
      (merge namespace-schema
             custom-fields))))

;; List of attributes that have multiple differing labels:
(defn fields-with-multiple-labels
  []
  (->> namespace-ordered-schemas
       (mapcat (fn [[et fields]]
                 (->> fields
                      (map (fn [[f fs]]
                             [f et fs])))))
       (group-by first)
       (filter (fn [[_f field-schemas]]
                 (< 1 (count field-schemas))))
       (map (fn [[f field-schemas]]
              [f
               (->> field-schemas
                    (map (fn [[_f _et fs]]
                           (->> fs
                                :field/translations
                                :en)))
                    distinct)]))
       (filter (fn [[_f labels]]
                 (< 1 (count labels))))))

;; Some fields have duplicate definitions based on entity-type.
;; You can run the above 'fields-with-multiple-labels' for some examples.
;; Mapping through 'namespace-ordered-schemas' in 'cross-entity-schema'
;; causes 'get-field-schema' to pick one arbitrarily.
;; Here you can ensure more general definitions are chosen,
;; i.e. deep-merged over the arbitrarily chosen one
;; (e.g. label "Association source" instead of "Contact").
;; Typically you should use an explicit entity schema instead of
;; 'get-field-schema' if the entity-type is already known.
(def resolved-duplicates
  {:entity-association/source-entity
   {:field/translations {:en "Association source"}}
   :entity-association/target-entity
   {:field/translations {:en "Association target"}}
   :entity-association/source-comment
   {:field/translations {:en "Association source comment"}}
   :entity-association/target-comment
   {:field/translations {:en "Association target comment"}}
   :entity-association/type
   {:field/translations {:en "Association type"}}
   :tenant.inbox/email
   {:field/translations {:en (->> :entity.type/tenant
                                  (get-schema nil)
                                  :tenant.inbox/email
                                  :field/translations
                                  :en)}}})

(def static-cross-entity-schema
  (potpuri/deep-merge
   (->> namespace-ordered-schemas
        (map (fn [[_ entity-schema]]
               entity-schema))
        (apply merge))
   resolved-duplicates))

(defn cross-entity-schema
  [tenant]
  (if-not tenant
    static-cross-entity-schema
    (potpuri/deep-merge
     static-cross-entity-schema
     (->> tenant
          :tenant/custom-field-definitions
          (map (fn [f]
                 [(:field/attribute f)
                  (select-keys f
                               (concat [:db/id :field/name :field/short-name
                                        :field/field-type :field/for-entity-types :field/data-type
                                        :field/for-entity-types]
                                       (keys custom-field/FieldSchema)))]))
          (map (fn [[k m]]
                 (add-field-defaults k m (first (:field/for-entity-types m)) static-cross-entity-schema)))
          (into {})))))

(defn- group-triggers
  [triggers]
  (->> triggers
       (group-by first)
       (mapv (fn [[entity-type et-triggers]]
               [entity-type (->> et-triggers
                                 (mapcat second)
                                 (distinct)
                                 (seq)
                                 (vec))]))
       (into {})))

(defn get-calc-triggers
  [tenant-schema]
  (->> tenant-schema
       (mapv val)
       (mapcat :calculation-triggers)
       (group-triggers)))

(defn- deep-index-triggers
  "The triggers of the deep-indexed references. A document holds the fields of an
   entity that a deep-indexed reference points to. When that entity changes, the
   documents that point to it must be built again, so the trigger goes back over
   the reference (`:oppo/_target-asset` for `:oppo/target-asset`)."
  [tenant-schema]
  (->> tenant-schema
       (keep (fn [[attribute field-schema]]
               (when (and (keyword? attribute)
                          (namespace attribute)
                          (:field/deep-indexing? field-schema)
                          (data-types/ref-type? (:field/data-type field-schema)))
                 (let [reverse-attribute (keyword (namespace attribute) (str "_" (name attribute)))]
                   (map (fn [entity-type]
                          [entity-type [[reverse-attribute]]])
                        (assets/concrete-entity-types (:field/entity-types field-schema)))))))
       (apply concat)))

(defn get-index-triggers
  "The triggers that build documents again when another entity changes: the
   `:calculation-triggers` of the calculated fields and the triggers of the
   deep-indexed references. A map from the type of the changed entity to the
   paths of attributes that lead to the documents."
  [tenant-schema]
  (->> tenant-schema
       (mapv val)
       (mapcat :calculation-triggers)
       (concat (deep-index-triggers tenant-schema))
       (group-triggers)))

;; attribute can be a keyword (such as :oppo/name)
;;  or a reference to another entity's attribute in the
;;  form of a vector (such as [:oppo/target-asset :asset/name])
(defn get-field-schema
  [tenant-schema attribute]
  (let [entity-attribute (cond (keyword? attribute)
                               attribute
                               (vector? attribute)
                               (peek attribute)
                               (sequential? attribute)
                               (->> attribute
                                    last)
                               :else
                               nil)]
    (if tenant-schema
      (get tenant-schema entity-attribute)
      (get static-cross-entity-schema entity-attribute))))

(defn max-string-len-constraint
  [tenant-schema attribute]
  (->> attribute
       (get-field-schema tenant-schema)
       :field/constraints
       :constraint/string-max-length))

(defn min-string-len-constraint
  [tenant-schema attribute]
  (->> attribute
       (get-field-schema tenant-schema)
       :field/constraints
       :constraint/string-min-length))

(defn get-unique-string-attributes
  [entity-type]
  (let [entity-schema (get-schema nil entity-type)]
    (->> entity-schema
         (keep (fn [[attribute-name field-schema]]
                 (when (or (->> field-schema
                                :field/constraints
                                :constraint/unique-tenant-ignore-case)
                           (->> field-schema
                                :field/constraints
                                :constraint/unique-tenant-ignore-case-additional-attribute))
                   attribute-name))))))

(defn find-name-attribute
  [_entity-type entity-schema]
  (let [name-attribute (->> entity-schema
                            (keep (fn [[_attribute-name field-schema]]
                                    (:field/name-attribute field-schema)))
                            (first))]
    name-attribute))

(def name-attributes
  (->> namespace-ordered-schemas
       (reduce-kv (fn [result entity-type entity-schema]
                    (if-let [name-attribute (find-name-attribute entity-type entity-schema)]
                      (assoc result entity-type name-attribute)
                      result))
                  {:entity.type/named-value :named-value/value})))

(defn resolve-name-attribute
  [entity-type & [logger]]
  (let [name-attribute (get name-attributes entity-type)]
    (when (and (not name-attribute)
               logger)
      (logger (str "Could not resolve name attribute for " entity-type)))
    name-attribute))

(def lower-case-attributes
  (->> ordered-schemas
       (reduce-kv (fn [res et schema]
                    (let [lower-case-attributes (->> schema
                                                     (filter #(-> %
                                                                  second
                                                                  :field/lower-case-str?))
                                                     (map first))]
                      #?(:clj
                         (when (cu/multiple? lower-case-attributes)
                           (throw (Exception. (str "Only 1 lower-case-attribute allowed for "
                                                   et
                                                   ": "
                                                   (pr-str lower-case-attributes))))))
                      (if (empty? lower-case-attributes)
                        res
                        (assoc res et (first lower-case-attributes)))))
                  {})))

(defn ref-field?
  [tenant-schema field]
  (let [{:field/keys [data-type artificial?
                      calculated-field]} (get-field-schema tenant-schema field)]
    (and (or (= data-type :data.type/ref-single)
             (= data-type :data.type/ref-multi))
         (not artificial?)
         (not calculated-field))))

(defn ref-multi?
  [tenant-schema field]
  (let [{:field/keys [data-type artificial?
                      calculated-field]} (get-field-schema tenant-schema field)]
    (and (= data-type :data.type/ref-multi)
         (not artificial?)
         (not calculated-field))))

(defn ref-single?
  [tenant-schema field]
  (let [{:field/keys [data-type artificial?
                      calculated-field]} (get-field-schema tenant-schema field)]
    (and (= data-type :data.type/ref-single)
         (not artificial?)
         (not calculated-field))))

(defn edn-field?
  [tenant-schema field]
  (let [{:field/keys [data-type artificial?
                      calculated-field]} (get-field-schema tenant-schema field)]
    (and (= data-type :data.type/text-edn)
         (not artificial?)
         (not calculated-field))))

;; Fields anywhere in the schema where an entity of `entity-type` can be the
;; value - i.e. the reverse side of a ref, discoverable via Datomic's native
;; :ns/_attr accessor (e.g. (-> company :investor/_legal-entity)). Used in
;; production by backend.domain.updates.topics.context.entity-scope's
;; generic reverse-pointer discovery.
(defn reverse-ref-fields
  [tenant-schema entity-type]
  (let [customer-types (set assets/customer-types)
        asset-types (set assets/all-asset-types)
        asset? (contains? asset-types entity-type)
        customer? (contains? customer-types entity-type)
        matching-entity-type-set (set/union
                                  #{entity-type :entity.type/any}
                                  (when asset?
                                    #{:entity.type/asset})
                                  (when customer?
                                    #{:entity.type/customer}))]
    (->> tenant-schema
         (filter (fn [[_k {:keys [field/entity-types]}]]
                   (some matching-entity-type-set entity-types)))
         (filter (fn-> second :field/data-type #{:data.type/ref-single :data.type/ref-multi}))
         (remove (fn-> second :field/artificial?))
         (remove (fn-> second :field/calculated-field)))))

(defn reverse-pointer-attributes
  "All non-calculated, non-artificial ref attributes anywhere in the schema
  that can point AT `entity-type` (including via the :entity.type/asset and
  :entity.type/customer abstract-type conventions), as a set of attribute
  keywords ready for common.util/reverse-attribute."
  [tenant-schema entity-type]
  (->> (reverse-ref-fields tenant-schema entity-type)
       (map first)
       set))

(defn reverse-single-ref-fields
  [tenant-schema {:keys [exclude] :as _opts} entity-type]
  (let [exclude (set exclude)]
    (->> (reverse-ref-fields tenant-schema entity-type)
         (filter (fn-> second :field/data-type (= :data.type/ref-single)))
         (map first)
         (remove exclude)
         sort)))

(defn resolve-refs
  [tenant]

  ;; all fields where a company can be the value (corresponds to reverse-attribute, e.g.. (-> company :investor/_legal-entity))
  ;; TODO define on field (schema) level how these should behave when deleting the entity:
  ;; potential approaches: :retract-on-target-delete? true (e.g. :investor/legal-entity)
  ;;                        -when deleting a company => [[:db/retract investor-id :investor/legal-entity deleted-company-id]]
  ;;                       :prevent-target-delete? true (e.g. :oppo/target-asset)
  ;;                        -don't allow deleting a company when it's a target-asset for any deals
  ;;  -cascading delete? (e.g. when deleting pipeline also delete all pipeline-stages?)
  ;; -can the behavior depend on the target entity-type? (e.g. retract field for fof-assets but prevent delete for companies)
  ;;  -can the behavior depend on the use case? (e.g. prevent delete by default but retract field when passing force-delete? true)
  ;; -same for multi-refs
  (reverse-single-ref-fields (cross-entity-schema tenant)
                             {:exclude #{:entity-association/source-entity
                                         :entity-association/target-entity}}
                             :entity.type/company)

  ;; => (:common/containing-entity
  ;;     :company/fullcontact-company
  ;;     :company/intelligence-company
  ;;     :fof-asset/gp
  ;;     :fund/general-partner
  ;;     :fund/management-company
  ;;     :holding/target-asset
  ;;     :investor/legal-entity
  ;;     :kpi-member/asset
  ;;     :kpi-report/company
  ;;     :oppo/target-asset
  ;;     :person/company
  ;;     :person/fullcontact-person
  ;;     :person/intelligence-person
  ;;     :role/target
  ;;     :sale-agreement/customer
  ;;     :sales-opportunity/customer)
  )

(def named-value-entity-type-lookup
  (->> ordered-schemas
       (mapcat second)
       (map second)
       (keep :named-value-attribute)
       (map (fn [nva]
              [nva (->> ordered-schemas
                        (keep (fn [[et et-schema]]
                                (when (get et-schema nva)
                                  et)))
                        (set))]))
       (into {})))

(defn pipeline-attribute?
  [attr]
  (some (set (get named-value-entity-type-lookup attr))
        entity-types/pipeline-entity-types))
